var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReleaseNotesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 5.5H26.5V12.9396C27.3891 13.2099 28.2282 13.5951 29 14.0778V5.5V3H26.5H5.5H3V5.5V26.5V29H5.5H14.8317C14.2964 28.2351 13.8604 27.3955 13.5426 26.5H5.5V5.5ZM13.057 21.4167C12.9802 21.9289 12.9404 22.4532 12.9404 22.9868C12.9404 23.187 12.946 23.3859 12.9571 23.5833H8.41667V21.4167H13.057ZM14.7559 17.0833C14.2992 17.754 13.918 18.4803 13.6248 19.25H8.41667V17.0833H14.7559ZM21.0939 12.75C19.4585 13.1233 17.9685 13.8785 16.7227 14.9167H8.41667V12.75H21.0939ZM23.5833 8.41667H8.41667V10.5833H23.5833V8.41667Z",
    fill: "#A79FBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7209 15.968L23.4404 13.9868L21.1598 15.968L18.1503 15.7057L17.4698 18.649L14.8809 20.2057L16.0604 22.9868L14.8809 25.768L17.4698 27.3247L18.1503 30.268L21.1598 30.0056L23.4404 31.9868L25.7209 30.0056L28.7304 30.268L29.4109 27.3247L31.9999 25.768L30.8204 22.9868L31.9999 20.2057L29.4109 18.649L28.7304 15.7057L25.7209 15.968ZM23.3243 26.3707L28.8243 20.8707L27.0565 19.1029L22.4404 23.719L19.8243 21.1029L18.0565 22.8707L21.5565 26.3707L22.4404 27.2546L23.3243 26.3707Z",
    fill: "#A79FBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReleaseNotesIcon);
export default __webpack_public_path__ + "static/media/Release_notes_icon.313f2ad53c4d54b3568db16d49df668a.svg";
export { ForwardRef as ReactComponent };